module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Foreword#fm-1"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(" by Adele Reinhartz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/006_Preface#fm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/007_Part01#pt-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 1: THE STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/007_Part01#sec-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 28:3–25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/007_Part01#sec-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biblical Tale of Thriving in Hard Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/007_Part01#sec-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Biblical Story of the Wise Witch of Endor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART 2: THE LESSONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Part02#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Know Your Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Part02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Strive to Excel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Part02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Choose the Moment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Part02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Win Well")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Final#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Final Word")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f02093a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0